import { Instance, Objekt } from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from './assetService';
import { LanguageService } from './languageService';
import { ModelService } from './modelService';

export class AreaService extends ModelService {
    static readonly inject = ['instances', 'languageService', 'assetService'];

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
    ) {
        super('area-areas-code', instances, $languageService, $assetService);
    }

    getAllByOrganization(organizationId: string, opt_params?: object) {
        return this.getAllBy('organizations', organizationId, opt_params);
    }

    createByOrganization(organizationId: string, area: Objekt) {
        return this.createBy('organizations', organizationId, area);
    }
}

export const areaService = app.service('areaService', AreaService);
